import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, FileText } from "lucide-react";

const CTABand = () => {
  return (
    <section data-testid="cta-band" className="relative py-16 lg:py-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="relative overflow-hidden rounded-3xl border border-[var(--gold)]/20 bg-gradient-to-br from-[#131313] via-[#0e0e10] to-[#0a0a0c] p-10 lg:p-16"
        >
          <div className="pointer-events-none absolute inset-0 opacity-70">
            <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.22),transparent_60%)] blur-2xl" />
            <div className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.14),transparent_60%)] blur-2xl" />
          </div>

          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <div className="mb-4 flex items-center gap-3">
                <div className="h-px w-8 bg-[var(--gold)]/60" />
                <span className="font-mono-label text-[var(--gold)]">Ready?</span>
              </div>
              <h2 className="font-display text-4xl leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[52px]">
                Ready to build<br />
                <span className="font-serif-display italic gold-gradient-text">
                  something bigger?
                </span>
              </h2>
              <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-zinc-400">
                Whether you&apos;re launching your first business or your next
                big idea — let&apos;s create something people won&apos;t forget.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-3">
              <a href="#contact" data-testid="cta-band-consult" className="btn-gold">
                Start Now
                <ArrowUpRight className="h-4 w-4" strokeWidth={2.2} />
              </a>
              <a href="#contact" data-testid="cta-band-quote" className="btn-ghost">
                <FileText className="h-4 w-4" strokeWidth={1.8} />
                Book Strategy Call
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABand;
